import React, { memo, Fragment, useEffect, useMemo, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import LOG from '../../logging/Logger'
import { isAtFreeLimit, hasSubscription } from '../EnforceLimit'
// import { FOCUS } from '../../data/focus'

const SubscriptionLevels = memo(
  ({ getUnfilteredTodos, getUnfilteredProjects, getAreas }) => {
    LOG.debug('Render: SubscriptionLevels')

    const todoCount = useMemo(() => getUnfilteredTodos().length, [
      getUnfilteredTodos
    ])
    const projectCount = useMemo(() => getUnfilteredProjects().length, [
      getUnfilteredProjects
    ])
    const areaCount = useMemo(() => getAreas(false).length, [getAreas])

    // const completedCount = useMemo(
    //   () =>
    //     getUnfilteredTodos().filter(todo => {
    //       return todo.status === 'done' && todo.list !== FOCUS.TRASH.id
    //     }).length,
    //   [getUnfilteredTodos]
    // )

    // const deletedCount = useMemo(
    //   () => getUnfilteredTodos(FOCUS.TRASH.id).length,
    //   [getUnfilteredTodos]
    // )

    const [limitHit, setLimitHit] = useState(false)

    useEffect(() => {
      const hasHitLimit = async () => {
        const hitLimit =
          isAtFreeLimit(todoCount, projectCount, areaCount) &&
          !(await hasSubscription())

        setLimitHit(hitLimit)
      }
      hasHitLimit()
    }, [todoCount, projectCount, areaCount])

    //const classes = useStyles()

    return (
      <Fragment>
        {limitHit && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography color={'secondary'} variant='body1' gutterBottom style={{fontWeight: 500}}>
                Try Getting Focused Risk free for 30 days!
              </Typography>
              <Typography variant='body2'>
                If you subscribe and don't love Getting Focused, let us know in
                the first 30 days and we'll give you a full refund.
              </Typography>
            </Grid>
          </Grid>
        )}
        <br />
        {/* <Typography variant='subtitle2'>Current Usage:</Typography>
        <SubscriptionLevel
          isHeader={true}
          itemName=''
          currentCount=''
          freeCount='Free Plan'
          subscriptionCount='Paid Plan'
        />
        <SubscriptionLevel
          itemName='Todos'
          currentCount={todoCount}
          freeCount={MAX_FREE_TIER_TODOS}
          subscriptionCount={MAX_SUBSCRIPTION_TODOS}
        />
        <SubscriptionLevel
          itemName='Projects'
          currentCount={projectCount}
          freeCount={MAX_FREE_TIER_PROJECTS}
          subscriptionCount={MAX_SUBSCRIPTION_PROJECTS}
        />
        <SubscriptionLevel
          itemName='Areas'
          currentCount={areaCount}
          freeCount={MAX_FREE_TIER_AREAS}
          subscriptionCount={MAX_SUBSCRIPTION_AREAS}
        />
        <Divider /> */}
      </Fragment>
    )
  }
)

export default SubscriptionLevels
